export const CONVERSATION_ROUTE_NAMES = {
  INDEX: "teacherConversationsIndex",
  OVERVIEW: "teacherConversations",
  OVERVIEW_PLANNED: "teacherConversationsPlanned",
  OVERVIEW_COMPLETED: "teacherConversationsCompleted",
  DETAIL: "teacherConversationDetail",
  STUDENT_OVERVIEW: "studentConversations",
  STUDENT_OVERVIEW_PLANNED: "studentConversationsPlanned",
  STUDENT_OVERVIEW_COMPLETED: "studentConversationsCompleted",
  STUDENT_DETAIL: "studentConversationDetail",
  STUDENT_PREPARE_CREATE: "studentConversationPrepareCreate",
  STUDENT_PREPARE_EDIT: "studentConversationPrepareEdit",
  INVITATION_CREATE: "teacherConversationInvitationCreate",
  INVITATION_EDIT: "teacherConversationInvitationEdit",
  INVITATION_DETAIL: "teacherConversationInvitationDetail",
  MENTOR_CLASS_DETAIL: "classroomMentorClassConversationDetail",
  MENTOR_CLASS_INVITATION_CREATE:
    "classroomMentorClassConversationInvitationCreate",
  MENTOR_CLASS_INVITATION_DETAIL:
    "classroomMentorClassConversationInvitationDetail",
  MENTOR_CLASS_INVITATION_EDIT:
    "classroomMentorClassConversationInvitationEdit",
  LESSON_CLASS_DETAIL: "classroomLessonClassConversationDetail",
  LESSON_CLASS_INVITATION_CREATE:
    "classroomLessonClassConversationInvitationCreate",
  LESSON_CLASS_INVITATION_DETAIL:
    "classroomLessonClassConversationInvitationDetail",
  LESSON_CLASS_INVITATION_EDIT:
    "classroomLessonClassConversationInvitationEdit",
} as const;

export type ConversationRouteName =
  (typeof CONVERSATION_ROUTE_NAMES)[keyof typeof CONVERSATION_ROUTE_NAMES];
